import { useStore } from '../../app/stores/store';
import { Button, Dropdown } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import { ThreeDotLoader } from '../../app/layout/LoadingComponent';
import { returntaskStatus } from '../../app/stores/CRMStore/types';
import { toast } from 'react-toastify';
import { getNextTaskOrSubTaskId } from '../../app/stores/NFAI_Restoration_Smartflow/types';
import { Dispatch, SetStateAction, useEffect } from 'react';

const InputAndButtonComponent = ({setPageNumber}:{setPageNumber:Dispatch<SetStateAction<number>>}) => {
  const {
    TrackingReportStore,
    userStore: { user },
    NFAI_Restoration_SmartflowsStore,
    viewStore,
  } = useStore();
  const {
    showButton,
    dropdownDetails,
    titileInformation: { activeInformation },
    handleComponents,
    titleFilter,
    reelFilter,
    employeeIdFilter,
    employeeNameFilter,
    updateFilterData,
    resetButtons,
    subtaskCompoent,
  } = NFAI_Restoration_SmartflowsStore;
  const {
    titleList,
    selectedTitle,
    reelList,
    selectedReel,
    empIdList,
    selectedEmpId,
  } = dropdownDetails;
  const { HandleCutlistReelAnaylsis } = viewStore;
  const { id, title, taskName, taskId, subtaskName, subtaskId, taskData } =
    activeInformation;

  useEffect(() => {
    titleFilter();
    employeeNameFilter();
    employeeIdFilter();
    // eslint-disable-next-line
  }, []);
  const buttonUpdate = async (statusNumber: number) => {
    if(taskName === 'Cutlist Quality Check' && subtaskName === 'Quality Check') {

      // const data:any = titileInformation.details.find(x => x.id === TrackingReportStore.ActiveRowId)
      //   const now =  new Date();
      //   const params: QcProps = {
      //     ...initialQcProps,
      //     id,
      //     date: now.toLocaleDateString(),  
      //     reportTime: now.toLocaleTimeString(),
      //     projectName: title,
      //     team: user?.addressLine1 || "",
      //     operatorId: data['Emp_ID'] || "",
      //     operatorName: data['Emp_Name'] || "",
      //     q_EmpId: user?.displayName|| "",
      //     q_EmpName: user?.username || "",
      //     process: statusNumber.toString() === '0' ? 'Yet to Start' : statusNumber.toString() === '1' ? 'Started' : statusNumber.toString() === '3' ? 'Hold': statusNumber.toString() === '4' ? 'Resumed' : 'InProgress',
      //     resolution: '',
      //     reel: data['Reel_No'] || "",
      //     shot: data['Shot_No'] || "",
      //     startFrame: data['Start_Frame'] || "",
      //     endFrame: data['End_Frame'] || "",
      //     totalFrame: data['Total_Frames'] || "",
      //     appFrames: 0,
      //     rejFrames: 0,
      //     status: statusNumber.toString(),
      // }
      // await agent.NFAIReport.QCworkingHours(params)
    }
    NFAI_Restoration_SmartflowsStore.errorMessage = {};
    NFAI_Restoration_SmartflowsStore.onSubmitChecker = false;
    NFAI_Restoration_SmartflowsStore.isMandatory = false;
    if (
      taskName === 'Full Restoration' &&
      subtaskName === 'Restoration' &&
      statusNumber === 1
    ) {
      try {
        await HandleCutlistReelAnaylsis(id || '', 'smartFlow');
        // if (viewStore.NFAIReportCutlistCheck) {
        //   toast.info('Reel Analysis file has to upload to start cutlist ');
        //   return;
        // }
      } catch (error) {
        console.log('Cutlist start paresed error', error);
      }
    }
    if (statusNumber === 2) {
      await NFAI_Restoration_SmartflowsStore.handlOnSubmit();
      if (NFAI_Restoration_SmartflowsStore.isMandatory) {
        toast.info('Kindly fill mandatory field!');
        return;
      }
    }
    NFAI_Restoration_SmartflowsStore.subtaskCompoent.isModel = false;
    // const nextTaskId = getNextTaskId(taskData.tasks, taskId,subtaskId);
    // const nextSubTaskId = getNextSubTaskId(taskData.tasks, taskId, subtaskId);
    const { nextTaskId, nextSubtaskId } = getNextTaskOrSubTaskId(
      taskData.tasks,
      taskId,
      subtaskId,
    );
    const statusPayload = {
      itemId: id,
      templateId: taskData.templateId,
      currentTaskId: taskId,
      nextTaskId: nextTaskId,
      currentSubtaskId: subtaskId,
      nextSubTaskId: nextSubtaskId,
      actionerName: user?.displayName || '',
      status: statusNumber,
      taskCount: 0,
      totalTask: taskData.tasks.length,
    };
    const historyPayload = {
      taskId: taskId,
      taskName: taskName,
      subTaskId: subtaskId,
      subTaskName: subtaskName,
      status: `${user?.displayName} ${returntaskStatus(
        statusNumber,
      )} working on ${subtaskName} for  ${title}`,
      date: new Date(),
    };
    const statusUpdate = {
      id: subtaskId,
      itemId: id,
      SubTkStatus: statusNumber.toString(),
    };
    const restorationPayload = {
      itemLevelId: id,
      taskId: taskId,
      taskName: taskName || '',
      subTaskId: subtaskId,
      subTaskName: subtaskName,
      currentUser: user?.displayName,
      actionName: statusNumber.toString() || '',
      titleStatus: selectedTitle || '',
    };

    const tablePayload = {
      itemId: id,
      status: statusNumber,
      subTaskId: subtaskId,
      subTaskName: subtaskName,
      taskId: taskId,
      taskName,
      title,
    };
    handleComponents(
      statusNumber,
      restorationPayload,
      statusPayload,
      historyPayload,
      statusUpdate,
      tablePayload,
    );
  };
 const updateDropdown  = (name:string,data:string) => {
  resetButtons();
  setPageNumber(1);
  updateFilterData(name, data);
  subtaskCompoent.isModel = false;
 }
  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '85%',
          marginLeft: '40px',
        }}
      >
        <div>
          <Dropdown
            style={{ margin: '5px' }}
            downward
            clearable
            options={titleList}
            selection
            search
            placeholder="Select Title"
            onChange={(e: any, data: any) => {
              updateDropdown('title',data.value)
              if (data.value === '') {
                dropdownDetails.reelList = [];
                return;
              }
              reelFilter(data.value);
            }}
            value={selectedTitle || ''}
          />
          {user?.roleName !== 'Operator' && (
            <>
              <Dropdown
                style={{ margin: '5px' }}
                downward
                clearable
                search
                options={reelList || []}
                selection
                placeholder="Select Reel"
                onChange={(e: any, data: any) =>
                  updateDropdown('reel',data.value)
                }
                value={selectedReel || ''}
              />
              <Dropdown
                style={{ margin: '5px' }}
                downward
                clearable
                search
                options={empIdList || []}
                selection
                placeholder="Select Emp Id"
                onChange={(e: any, data: any) =>
                  updateDropdown('empId',data.value)
                }
                value={selectedEmpId || ''}
              />
              {/* <Dropdown
                style={{ margin: '5px' }}
                downward
                clearable
                search
                options={empNameList || []}
                selection
                placeholder="Select Emp Name"
                onChange={(e: any, data: any) =>
                  updateDropdown('empName',data.value)
                }
                value={selectedEmpName || ''}
              /> */}
            </>
          )}
        </div>
        <div>
          {TrackingReportStore.isSmartTrackerButtonLoading ? (
            <div
              style={{ position: 'relative', width: '40px', height: '48px' }}
            >
              <ThreeDotLoader />
            </div>
          ) : (
            <>
              {showButton.start && (
                <Button onClick={() => buttonUpdate(1)} color="blue">
                  Start
                </Button>
              )}
              {showButton.complete && (
                <Button.Group floated="right">
                  <Button color="blue" onClick={() => buttonUpdate(2)}>
                    {' '}
                    Complete{' '}
                  </Button>
                  <Button.Or />
                  <Button
                    color="yellow"
                    //openHold
                    onClick={() => buttonUpdate(3)}
                  >
                    {' '}
                    Hold
                  </Button>
                </Button.Group>
              )}

              {showButton.Resume === true && (
                <Button onClick={() => buttonUpdate(4)}> Resume </Button>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};
export default observer(InputAndButtonComponent);
